import { useChatContext } from "@/contexts/chatContext";
import { Box } from "@repo/components/src/ui/box";
import { Heading } from "@repo/components/src/ui/heading";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { MessageCircle } from "lucide-react-native";
import React from "react";
import ListChatMessages from "./list";

type MessagesProps = {
  showHeader?: boolean;
};

const Messages = React.memo((props: MessagesProps) => {
  const { selectedChatId } = useChatContext();
  if (!selectedChatId) {
    return (
      <VStack
        space="md"
        className="flex-1 items-center justify-center px-8 py-16 bg-background-50"
      >
        <Box className="p-5 rounded-2xl bg-brand-50 border border-brand-100">
          <Icon as={MessageCircle} className="text-brand-500 w-10 h-10" />
        </Box>
        <VStack space="xs" className="items-center">
          <Heading size="md" className="text-center">
            Selecciona una conversación
          </Heading>
          <Text size="sm" action="muted" className="text-center max-w-xs">
            Elige un chat de la lista para leer o responder mensajes.
          </Text>
        </VStack>
      </VStack>
    );
  }
  return (
    <ListChatMessages
      selectedChatId={selectedChatId}
      showHeader={props.showHeader}
    />
  );
});

Messages.displayName = "Messages";

export default Messages;
